import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";

export default function ChangePasswordPage() {
  const nav = useNavigate();
  const { user, refresh } = useAuth();
  const [oldPw, setOldPw] = useState("");
  const [newPw, setNewPw] = useState("");
  const [confirmPw, setConfirmPw] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (newPw.length < 8) return toast.error("Kata sandi baru minimal 8 karakter");
    if (newPw !== confirmPw) return toast.error("Konfirmasi kata sandi tidak cocok");
    setLoading(true);
    try {
      await api.post("/auth/change-password", { old_password: oldPw, new_password: newPw });
      toast.success("Kata sandi berhasil diubah");
      await refresh();
      nav(user?.role === "admin" ? "/infaq/bendahara" : "/infaq/pj-kelas");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Gagal mengubah kata sandi");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#FAF8F5] flex items-center justify-center px-4">
      <Card className="w-full max-w-md p-6 sm:p-8">
        <div className="flex items-center gap-2 text-[#1B4D3E] mb-1">
          <KeyRound size={20} />
          <h1 className="text-xl font-bold">Ganti Kata Sandi</h1>
        </div>
        <p className="text-sm text-[#64748B] mb-6">Demi keamanan akun, mohon ganti kata sandi awal Anda.</p>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label>Kata Sandi Lama</Label>
            <Input type="password" value={oldPw} onChange={(e) => setOldPw(e.target.value)} required data-testid="change-old-pw-input" />
          </div>
          <div>
            <Label>Kata Sandi Baru (min. 8 karakter)</Label>
            <Input type="password" value={newPw} onChange={(e) => setNewPw(e.target.value)} required data-testid="change-new-pw-input" />
          </div>
          <div>
            <Label>Konfirmasi Kata Sandi Baru</Label>
            <Input type="password" value={confirmPw} onChange={(e) => setConfirmPw(e.target.value)} required data-testid="change-confirm-pw-input" />
          </div>
          <Button type="submit" disabled={loading} className="w-full bg-[#1B4D3E] hover:bg-[#143E32]" data-testid="change-pw-submit-btn">
            {loading ? "Memproses..." : "Simpan"}
          </Button>
        </form>
      </Card>
    </div>
  );
}
